import { PortableText } from 'next-sanity'
import { portableBlockComponents } from '@/utils/portableText'
import s from './SelectedWorkBlock.module.scss'

type Block = {
  title?: string
  contentLeft?: any[]
  contentRight?: any[]
}

type Props = { data?: Block | null }

export default function SelectedWorkBlock({ data }: Props) {
  if (!data) return null
  const { title, contentLeft, contentRight } = data
  const hasContent = Boolean(title || contentLeft?.length || contentRight?.length)
  if (!hasContent) return null

  return (
    <section className={s.block} aria-labelledby="selected-work-heading">
      <div className={s.inner}>
        {title && (
          <h2 id="selected-work-heading" className={s.title}>
            {title}
          </h2>
        )}
        <div className={s.content}>
          <div className={s.column}>
            {contentLeft?.map((textRow: any) => (
              <PortableText
                key={textRow._key}
                value={[textRow]}
                components={portableBlockComponents()}
              />
            ))}
          </div>
          <div className={s.column}>
            {contentRight?.map((textRow: any) => (
              <PortableText
                key={textRow._key}
                value={[textRow]}
                components={portableBlockComponents()}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
